import * as secureAssociationEnrollmentApi from '@/network/api/secureAssociationEnrollment.api.js'

/** Consult Secure Association
@return { Promise }
*/
export const consultSecureAssociation = async (context, payload) => {
    const res = await secureAssociationEnrollmentApi.consultSecureAssociation(payload)

    return res
}

/** Delete Secure Association Enrollment
@return { Promise }
*/
export const deleteSecureAssociation = async (context, payload) => {
    const res = await secureAssociationEnrollmentApi.deleteSecureAssociation(payload)

    return res
}

/** Initiate enrollment process
@return { Promise }
*/
export const initiateEnrollmentProcess = async (context, payload) => {
    const res = await secureAssociationEnrollmentApi.initiateEnrollmentProcess(payload)

    return res
}

/** Retry Initiate enrollment process
@return { Promise }
*/
export const retryInitiateEnrollmentProcess = async (context, payload) => {
    const res = await secureAssociationEnrollmentApi.retryInitiateEnrollmentProcess(payload)

    return res
}

/** Confirm enrollment process
@return { Promise }
*/
export const confirmEnrollmentProcess = async (context, payload) => {
    const res = await secureAssociationEnrollmentApi.confirmEnrollmentProcess(payload)

    return res
}
